/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import { Box, useStyleConfig } from "@chakra-ui/react";
import React from 'react';
function PanelContainer(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("PanelContainer", { variant });
  // Pass the computed styles into the `__css` prop
  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  );
}

export default PanelContainer;
